<template>
    <div>
      认证查询

      <div @click="handleDetail">点击详情</div>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
    }
  },
  methods: {
    handleDetail () {
      this.$router.push({ path: '/authenticationDetail' })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
